import React from 'react';
import StaggeredProductList from './../staggered-product-list/./staggered-product-list';
//@ts-ignore
import TaggedImage from './../tagged-image/./tagged-image';
//@ts-ignore
import Button from './../button/./button';
//@ts-ignore
import {GetCategoryBySlug,GetProductsBySubCategory} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import {GetFromParse} from './../../themes/kent/utilities/parse';
//@ts-ignore
import HorizontalProductScroller from './../horizontal-product-scroller/./horizontal-product-scroller';

/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  subcategories?: any;
  year?:any;
  decorativeText?:any;
}

interface IState {
  data?:any;
  quickCompareActiveIndex?:any;
}


class StaggeredSubcategoryList extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state ={};
  }

  componentDidMount = async() =>{
    let subcategories: any = this.props.subcategories;
    console.log(subcategories)
    let data: any = [];
    for (let index = 0; index < subcategories.length; index++) {
      console.log(subcategories[index].subcategoryId)
      let subcategory = await GetFromParse('Subcategories',subcategories[index].subcategoryId);
      console.log(subcategory)
      console.log(this.props.year)
      let products = await GetProductsBySubCategory(subcategory.id,this.props.year);
      console.log(products)
      if(window){
        if(window.location){
          if(window.location.href){
            if(window.location.href.indexOf('wakesurf') != -1){
              if(subcategory.id == 'whV2WTLw1O'){
                products = products.filter((prod:any) =>prod.attributes.slug && prod.attributes.slug.indexOf('surf') != -1)
              }
            }
          }
        }
      }
      data.push({
        taggedImage:subcategories[index].taggedImage,
        taggedImageProducts:subcategories[index].products,
        taggedImageAthletes:subcategories[index].riders,
        subcategory:subcategories[index].subcategoryId,
        subcategoryTitle:subcategories[index].name,
        displayQuickCompare:subcategories[index].displayQuickCompare,
        products:products
      })
      this.setState({
        data:data
      },()=>{
        this.checkForAnchorlink()
      })
    }
  }

  public checkForAnchorlink = () =>{
    if(typeof window !== "undefined"){
      if(window.location.hash){
        let hash:any = window.location.hash;
        if(hash){
          hash = hash.replace('#','')
          if(document){
            if(document.getElementById){
              let hashElem:any = document.getElementById(hash);
              if(hashElem){
                let hashTop:any = hashElem.offsetTop; //Getting Y of target element
                if(hashTop){
                  hashTop = hashTop +600;
                  if(window.scrollTo){
                    window.scrollTo(0, hashTop);
                  }

                }
              }
            }
          }
        }
      }
    }
  }

  public quickCompareClicked=(e:any,index:any)=>{
    console.log(index)
    this.setState({
      quickCompareActiveIndex:index
    })
  }
  public quickCompareDismissed=()=>{
    this.setState({
      quickCompareActiveIndex:-1
    })
  }

  public render(): JSX.Element {
    let decorativeFontClass = this.props.decorativeText ? "decorative-text" : "";
    return(
      <div className="secondary-background">
        <div className="max-width-container">
           <div className="full-width row staggered-list">
              {this.state.data && this.state.data.map((dataObj:any,index:any) => {
                let quickCompareActive:any = false;
                if(this.state.quickCompareActiveIndex == index){
                  quickCompareActive = true;
                }
                return(
                  <React.Fragment key={'subcat-'+index}>
                    {dataObj.subcategoryTitle &&
                      <div id={'sub-'+dataObj.subcategory} className={"small-12 medium-6 staggered-subcategory-header tiny-padding staggered-product-tile"}>
                        <div className="white-background full-width" style={{height:'100%'}}>
                          {dataObj.taggedImage ?
                            <TaggedImage
                              year={this.props.year}
                              image={dataObj.taggedImage.src}
                              products={dataObj.taggedImageProducts}
                              athletes={dataObj.taggedImageAthletes}
                              style={{height:'100%',width:'100%'}}
                            />
                            :
                            <div className="background-image-fill staggered-product-subcategory-break black-background"></div>
                          }
                        </div>
                        <div className="staggered-product-subcategory-overlay-container">
                          <div style={{position:'relative',zIndex:100}}>
                            <div style={{width:'50%',height:'5px', marginBottom:'10px', backgroundColor:"#fff"}}></div>
                            <div className="full-width">
                              {dataObj.subcategoryTitle && <h2 className={"full-width "+decorativeFontClass}>{dataObj.subcategoryTitle}</h2>}
                            </div>
                            {dataObj.displayQuickCompare &&
                              <span>
                                <span onClick={(e:any)=>this.quickCompareClicked(e,index)}>
                                  <Button text={'Quick Compare'} backgroundColor={'#fff'} color={'#000'} />
                                </span>
                                {quickCompareActive && <HorizontalProductScroller year={this.props.year} theme={'dark'} showStats={true} active={quickCompareActive} products={dataObj.products} dismissed={this.quickCompareDismissed} />}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    <StaggeredProductList
                      year={this.props.year}
                      parseKey={'subcategory'}
                      parseValue={dataObj.subcategory}
                      products={dataObj.products}
                    />
                  </React.Fragment>
                )})}
                <div style={{clear:'both'}}>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StaggeredSubcategoryList;
